import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import useAllPatients from '~/hooks/patient/useAllPatients';
import LoadedPatientData from './LoadedPatientData';
import LoadedPatientDataTree from './LoadedPatientDataTree';
import { ViewMode } from './ViewSwitcher';

export function EmptyList() {
    return (
        <Box display="grid" gap={1} p={2}>
            <Typography variant="body2" textAlign="center">
                <FormattedMessage id="noPatientDatasets" />
            </Typography>
        </Box>
    );
}

interface LoadedPatientsProps {
    viewMode: ViewMode;
}

export default function LoadedPatients({ viewMode }: LoadedPatientsProps) {
    const { patients } = useAllPatients();

    if (patients.length === 0) {
        return <EmptyList />;
    }

    return (
        <Box>
            {patients.map((patient) =>
                viewMode === 'table' ? (
                    <LoadedPatientData patient={patient} key={patient.id} />
                ) : (
                    <LoadedPatientDataTree patient={patient} key={patient.id} />
                )
            )}
        </Box>
    );
}
